import request from '@/utils/request'
import { parseStrEmpty } from '@/utils/ruoyi'




// 查询用户列表分页
export function pageAgent (query) {
  return request({
    url: '/system/agent/page',
    method: 'get',
    params: query
  })
}


// 查询用户列表
export function listAgent (query) {
  return request({
    url: '/system/agent/list',
    method: 'get',
    params: query
  })
}

// 查询用户详细
export function getUser (userId) {
  return request({
    url: '/system/user/' + parseStrEmpty(userId),
    method: 'get'
  })
}

// 新增用户
export function addAgent (data) {
  return request({
    url: '/system/agent/add',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateAgent (data) {
  return request({
    url: '/system/agent/edit',
    method: 'post',
    data: data
  })
}

// 删除用户
export function delAgent (userId) {
  return request({
    url: '/system/agent/delete',
    method: 'post',
    data: userId
  })
}


// 用户状态修改
export function changeUserStatus (id, status) {
  const data = {
    id,
    status
  }
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data
  })
}

// 导入用户
export function importData (data) {
  return request({
    url: '/system/agent/importData',
    method: 'post',
    data: data
  })
}


